<div class="wrapper">
    <div class="history-icon">
        <svg-icon src="assets/images/history.svg"></svg-icon>
    </div>
    <div class="item-name">
        {{item.name}}
    </div>
    <div class="filler"></div>
    <div class="actions">
        <div class="actions-wrapper" *ngIf="item.type === 'account'">
            <div *ngIf="item.data.accountType === 'customer'"
                (click)="createOrderWithCustomer(item.data)"
                class="icon-wrapper icon-call">
                <svg-icon src="assets/images/add-order.svg"></svg-icon>
            </div>
            <div class="icon-wrapper icon-call"
                (click)="callAccount(item.data)">
                <svg-icon src="assets/images/icon-phone.svg"></svg-icon>
            </div>
            <div class="icon-wrapper icon-messages"
                (click)="startChat(item.data)">
                <svg-icon src="assets/images/icon-messages.svg"></svg-icon>
            </div>
        </div>
        <ng-container *ngIf="item.type === 'product'">
            <a (click)="redirectToProductEdit(item.data)"
                class="link-wrapper edit-product">
                <span>
                    Edit
                </span>
            </a>
            <a (click)="redirectToPublicView(item.data)"
                class="link-wrapper">
                <svg-icon src="assets/images/redirect.svg"></svg-icon>
                <span>
                    View on frontstore
                </span>
            </a>
        </ng-container>
        <ng-container *ngIf="item.type === 'order'">
            <a (click)="goToOrder(item.data)">View order</a>
        </ng-container>
        <div class="remove-icon" (click)="$event.stopPropagation();removeHistoryItem()">
            <svg-icon src="assets/images/icon-menu-close.svg"></svg-icon>
        </div>
    </div>
</div>